// 自定义错误类型
class TimeoutError extends Error {
  constructor(message) {
    super(message);
    this.name = 'TimeoutError';
  }
}

class ImageLoader {
  constructor(maxConcurrency = 5, defaultTimeout = 3000) {
    this.maxConcurrency = maxConcurrency;
    this.queue = [];
    this.activeCount = 0;
    this.results = new Map(); // 用于记录索引和结果的映射
    this.defaultTimeout = defaultTimeout;
  }

  loadImages(images) {
    // 初始化队列，保存图片URL和原始索引
    images.forEach((item, index) => this.queue.push({ src: item.src, index }));
    return new Promise((resolve, reject) => {
      this.resolveAll = resolve;
      this.rejectAll = reject;
      this.processQueue();
    });
  }

  processQueue() {
    while (this.activeCount < this.maxConcurrency && this.queue.length > 0) {
      const { src, index } = this.queue.shift();
      this.activeCount++;

      this.loadImageWithTimeout(src)
        .then(([width, height]) => {
          this.results.set(index, { width, height, src });
          this.activeCount--;
          this.processQueue();
        })
        .catch(error => {
          console.error(`图片 ${src} 加载失败:`, error);
          this.results.set(index, { width: 1, height: 1, src, status: 'error' });
          this.activeCount--;
          this.processQueue();
        });
    }

    // 所有任务完成时触发
    if (this.queue.length === 0 && this.activeCount === 0) {
      this.resolveAll(Array.from(this.results.entries()).map(([index, item]) => ({ index, ...item })));
      this.results.clear();
    }
  }

  loadImageWithTimeout(url) {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new TimeoutError(`图片加载超时: ${url}`));
      }, this.defaultTimeout);
    });

    const loadPromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve([img.naturalWidth, img.naturalHeight, 'loaded']);
        URL.revokeObjectURL(img.src);
      };
      img.onerror = e => {
        reject(new Error(`加载失败: ${e.message}`));
      };
      img.src = url;
    });

    return Promise.race([loadPromise, timeoutPromise]);
  }
}

export default ImageLoader;
